import { render, staticRenderFns } from "./roznamcha.vue?vue&type=template&id=0cd4d165&"
import script from "./roznamcha.vue?vue&type=script&lang=js&"
export * from "./roznamcha.vue?vue&type=script&lang=js&"
import style0 from "./roznamcha.vue?vue&type=style&index=0&id=0cd4d165&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports